export * from "./queryStringPaginationOptions";
export * from "./regexp";
export * from "./userHelper";

export function getHHmmFromString(hhmm: string) {
  return new Date(
    0,
    0,
    0,
    Number(hhmm.slice(0, 2)),
    Number(hhmm.slice(2))
  ).toJSON();
}
